var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconDashboardMarketingSelected = function SvgIconDashboardMarketingSelected(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#3F94FF",
    strokeMiterlimit: 10,
    strokeWidth: 0.7,
    d: "M15.345.621H4.289A3.567 3.567 0 0 0 .723 4.188v11.055a3.567 3.567 0 0 0 3.566 3.567h11.056a3.567 3.567 0 0 0 3.566-3.567V4.188A3.567 3.567 0 0 0 15.346.62Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#3F94FF",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.7,
    d: "M3.988 14.953H14.7M3.988 13.078h8.734"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#3F94FF",
    strokeMiterlimit: 10,
    strokeWidth: 0.7,
    d: "M10.868 8.444 9.2 7.133M7.49 7.203 5.11 9.37M14.7 6.668l-2.167 1.767"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#3F94FF",
    d: "M15.533 7.211a1.211 1.211 0 1 0 0-2.422 1.211 1.211 0 0 0 0 2.422M11.701 10.325a1.211 1.211 0 1 0 0-2.423 1.211 1.211 0 0 0 0 2.423M8.322 7.746a1.211 1.211 0 1 0 0-2.422 1.211 1.211 0 0 0 0 2.422M4.322 11.301a1.211 1.211 0 1 0 0-2.422 1.211 1.211 0 0 0 0 2.422"
  })));
};
export default SvgIconDashboardMarketingSelected;